/**
 * @license
 * Copyright ACCEO Solution Inc. All Rights Reserved.
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the localstorage package.
 */
export * from './localstorage.module';
export * from './localstorage.service';
